var $3bb85aaf876c2abb$exports = {};
$3bb85aaf876c2abb$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "placeholder": `Izv\u{113}l\u{113}ties\u{2026}`
};


export {$3bb85aaf876c2abb$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
